module.exports = __webpack_public_path__ + "img/home_icon_wodekaquan.ea633dbe.svg";